// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3hRD-","icon":"header_icon__3N-6u"};